import {
  ADD_RECORD,
  GET_RECORD,
  GET_RECORD_LIST,
  UPDATE_RECORD,
  RESET_RECORD,
  UPDATE_WORKFLOW,
  RESET_WORKFLOW,
} from '@redturtle/volto-io-cittadino/actions/record';

const initialState = {
  loading: false,
  loaded: false,
  result: {},
  error: null,
};

// Save and add pratica
export const praticaRecord = (state = initialState, action = {}) => {
  switch (action.type) {
    case RESET_RECORD:
      return { ...initialState };
    case `${ADD_RECORD}_PENDING`:
    case `${UPDATE_RECORD}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
        action: 'save',
      };
    case `${ADD_RECORD}_SUCCESS`:
      return {
        ...state,
        result: action.result,
        error: null,
        loading: false,
        loaded: true,
        action: 'save',
      };
    case `${UPDATE_RECORD}_SUCCESS`:
      return {
        ...state,
        result: action.result,
        error: null,
        loading: false,
        loaded: true,
        action: 'save',
      };
    case `${ADD_RECORD}_FAIL`:
    case `${UPDATE_RECORD}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        action: 'save',
      };
    case `${GET_RECORD}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
        action: null,
      };
    case `${GET_RECORD}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
        action: null,
      };
    case `${GET_RECORD}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: true,
        action: null,
        error: action.error || 'Errore nel recupero della pratica',
      };
    default:
      return state;
  }
};

export const praticaWorkflow = (state = initialState, action = {}) => {
  switch (action.type) {
    case RESET_WORKFLOW:
      return { ...initialState };

    case `${UPDATE_WORKFLOW}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${UPDATE_WORKFLOW}_SUCCESS`:
      return {
        ...state,
        result: action.result,
        error: null,
        loading: false,
        loaded: true,
      };
    case `${UPDATE_WORKFLOW}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
      };
    default:
      return state;
  }
};

// Get Pratiche list
export const listPratiche = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_RECORD_LIST}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${GET_RECORD_LIST}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
      };
    case `${GET_RECORD_LIST}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
};
